module.exports = __webpack_public_path__ + "officialStatic/img/index-new-bg.ec74f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-new-bg.png
// module id = rOkd
// module chunks = 0